export const API_DEV_URL = 'https://api-dev.sportifyapp.co';
export const API_PROD_URL = 'https://api.sportifyapp.co';
export const AUTH_DEV_URL = 'https://auth.sportifyapp.co';
export const API_URL = window.location.href.includes('localhost') || window.location.href.includes('dev') ? API_DEV_URL : API_PROD_URL;
